<template>

  <loading-data-page-container
    :loading="!isInitialized && !loadingError"
    :loading-error="loadingError"
    :loading-error-message="loadingErrorMessage"
    :hint="loadingErrorHint"
    max-width>

    <template v-if="isInitialized && !loadingError">
          <div
           id="custom-header-quicknav"
           class="sticky-box fixed-box pt-8 pb-4">
            <v-btn color="primary" class="standard-button" @click="navTo('/produkte/privatkunden')">Privatkunden</v-btn>
            <v-btn color="primary" class="standard-button ml-8" @click="navTo('/produkte/privatkunden/sus')">Schnell &amp; Sicher</v-btn>
            <v-btn color="primary" class="standard-button ml-8" @click="navTo('/produkte/privatkunden/yolig')">YOLIG</v-btn>
    </div>
      <product-info-part1 :linkinfos="ProduktePrivat.items" :pibs="pibs" :hls="hls"/>
      <product-info-block :sections="ProduktePrivatWeitere.sections"
                          title="Weitere Unterlagen" />

    </template>

  </loading-data-page-container>

</template>


<script>

import ProductInfoPart1 from "@/components/productInfo/ProductInfoPart1.vue";
import ProductInfoBlock from "@/components/productInfo/ProductInfoBlock";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";

export default {
  name: "PrivatkundenPage",
  components: { ProductInfoPart1, ProductInfoBlock, LoadingDataPageContainer },
  mixins: [contentLoadingMixin([
    "ProduktePrivat",
    "ProduktePrivatWeitere",
    "PI_Standard",
    "PI_EXPERT",
    "PI_PRESTIGE",
    "PI_SUS",
    "PI_YOLIG",
    "HL_Standard",
    "HL_EXPERT",
    "HL_PRESTIGE",
    "HL_SUS",
    "HL_YOLIG"
  ])],
  computed: {
    pibs () {
      return {
        standard: this.PI_Standard.items[0],
        expert: this.PI_EXPERT.items[0],
        prestige: this.PI_PRESTIGE.items[0],
        sus: this.PI_SUS.items[0],
        yolig: this.PI_YOLIG.items[0]
      };
    },
    hls() {
      return {
        standard: this.HL_Standard.items[0],
        expert: this.HL_EXPERT.items[0],
        prestige: this.HL_PRESTIGE.items[0],
        sus: this.HL_SUS.items[0],
        yolig: this.HL_YOLIG.items[0]
      };
    }
  },
  watch: {
    isInitialized: {
      immediate: true,
      handler: function (newinit) {
        if ( newinit === true) {
          this.uriScroll();
        }
      }
    }
  },
  methods: {
    navTo (url) {
      if (this.$router.currentRoute.path === url) {
        window.scrollTo (0, 0);
        setTimeout(() => {this.uriScroll ();});
        setTimeout(() => {this.uriScroll ();});
      } else {
        this.$router.push({ path: url});
      }
    },
    uriScroll () {
      const uri = this.$router.currentRoute.path.split('/');  //window.location.href.
      if (uri[uri.length - 1] == 'yolig') {
        this.gotoYolig ();
      } else if (uri[uri.length - 1] == 'sus') {
        this.gotoSuS ();
      } else if (uri[uri.length - 1] == 'privatkunden')
      {
        this.gotoP ();
      }
    },
    gotoP () {
      window.scrollTo(0,0);
    },
    gotoSuS () {
      setTimeout(() => {
        var element = document.getElementById("sus-fixed-box");
        element.scrollIntoView({block: 'start', behavior: 'auto'});
        window.scrollBy(0, -84 - 48 - 16); // todo  add -88 dynamicly only if site header fully visible and get rid of timeouts
      }, 0);
    },
    gotoYolig () {
      //window.scrollTo (0, document.body.scrollHeight);
      setTimeout(() => {
        var element = document.getElementById("yolig-fixed-box");
        element.scrollIntoView({block: 'start', behavior: 'auto'});
        window.scrollBy(0, -84 - 48 - 16);
      }, 0);
    }
  }
};
</script>
<style>
 #custom-header-quicknav {
  background-color: white;
  /*
  width: 100vw;
  padding-left: calc(-1 * (100vw - 100%)/2);*/
 }
</style>